import { Note, SamplingClassification } from '../../../shared/types/notes/notes';
import {
  DEFAULT_UNCLASSIFIED_SAMPLING_MARKER_COLOR,
  resolveSamplingMarkerColor,
} from './colors';

export function buildClassificationNameMap(
  classifications: SamplingClassification[]
): Record<number, string> {
  return (classifications || []).reduce((acc, c) => {
    if (c && c.id != null) {
      acc[c.id] = c.name;
    }
    return acc;
  }, {} as Record<number, string>);
}

export function enrichNotesWithClassificationNames(
  notes: Note[],
  namesById: Record<number, string>,
  colorsById: Record<number, string> = {}
): Note[] {
  return (notes || []).map(note => {
    const classificationId = note.sampling && note.sampling.sampling_classification_id;
    const isSampling = note.sampling != null;

    return {
      ...note,
      sampling_classification_name:
        classificationId != null ? (namesById[classificationId] || null) : null,
      sampling_marker_color: isSampling
        ? resolveSamplingMarkerColor(classificationId, colorsById)
        : undefined,
    };
  });
}

export type UnclassifiedSampling = {
  id: number
  description?: string
  percent_damage?: number
}

/** Sampling notes with no classification assigned */
export function getUnclassifiedSamplingsFromNotes(
  notes: Note[]
): UnclassifiedSampling[] {
  return (notes || [])
    .filter(
      note =>
        note.sampling != null &&
        note.sampling.sampling_classification_id == null
    )
    .map(note => {
      const sampling = note.sampling!;
      return {
        id: sampling.id,
        description:
          sampling.description != null && String(sampling.description).trim() !== ''
            ? sampling.description
            : '-',
        percent_damage: sampling.percent_damage,
      };
    });
}

export { DEFAULT_UNCLASSIFIED_SAMPLING_MARKER_COLOR };
